export const Paths = {
  DEFAULT_PAGE: '/',

  STAFF_APPLICATIONS_PAGE: '/staff-applications',
  UPDATE_STAFF_APPLICATION_PAGE: '/staff-applications/update/:id',
  STAFF_APPLICATION_VIEW_PAGE: '/staff-applications/view/:id',
  STAFF_APPLICATIONS_SALARY_MEASUREMENTS_PAGE: '/staff-applications/salary-measurements',

  PCRS_PAGE: '/pcrs/list',
  PCR_CREATE_PAGE: '/pcrs/create',
  PCR_UPDATE_PAGE: '/pcrs/update/:id',
  PCR_KANBAN_BOARD: '/pcrs/:id/kanban-board',
  PCR_STATISTICS: '/pcrs/:id/statistics',

  PCR_PAY_SCALES: '/pcr-pay-scales',
  PCR_PAY_SCALE_CREATE_PAGE: '/pcr-pay-scales/create',
  PCR_PAY_SCALE_UPDATE_PAGE: '/pcr-pay-scales/update/:id',

  AUTH_LOGIN_PAGE: '/auth/login',
  AUTH_LOGOUT_PAGE: '/auth/logout',
  AUTH_STAFF_LOGIN_PAGE: '/auth/staff-login',
  AUTH_PCR_LOGIN_PAGE: '/auth/pcr-login',
  AUTH_OL_LOGIN_PAGE: '/auth/service-provider-login',
  AUTH_FORGOT_PASSWORD_PAGE: '/auth/forgot-password',
  AUTH_RESET_PASSWORD_PAGE: '/auth/reset-password',
  AUTH_AUTHENTICATE_TOKEN: '/auth/connect/:token',

  SYSTEM_ADMIN_USERS_LIST_PAGE: '/users/list',

  PCR_APPLICATIONS_PAGE: '/my-applications',
  PCR_PAYMENTS_PAGE: '/pcr-payments',

  SETTING_HOW_DID_YOU_HEAR_ABOUT_US: '/settings/how-did-you-hear-about-us',
  SETTING_HOBBIES: '/settings/hobbies',
  SETTING_TRANSPORT_MEANS: '/settings/transport-means',
  SETTING_ACCOMODATION_TYPES: '/settings/accomodation-types',
  SETTING_PERIODS: '/settings/periods',
  SETTING_TRIP_PLACES: '/settings/trip-places',
  SETTING_STAFF_COMMENT_SUBJECTS: '/settings/comment-subjects',
  SETTING_FORMULA_WISH_LIST: '/settings/formula-wish-list',
  SETTING_TRAVEL_COMPANIES: '/settings/travel-companies',

  PCR_PERSONAL_SPACE_SCORE_CARDS: '/pcr-personal-space/score-cards',
  PCR_PERSONAL_SPACE_KANBAN: '/pcr-personal-space/kanban',
  PCR_PERSONAL_SPACE_BASIC_STATISTICS: '/pcr-personal-space/basic-statistics',

  STAFF_PERSONAL_SPACE_INFORMATION: '/staff-personal-space/information',
  STAFF_PERSONAL_SPACE_CONTRACTS: '/staff-personal-space/contracts',
  STAFF_PERSONAL_SPACE_MISSIONS: '/staff-personal-space/missions',
  STAFF_PERSONAL_SPACE_MISSION_TRAVEL_EXPENSES:
    '/staff-personal-space/missions/:id/travel-expenses',
  STAFF_PERSONAL_SPACE_AVAILABILITY: '/staff-personal-space/availability',
  STAFF_PERSONAL_SPACE_PAY_SCALE_TABLE: '/staff-personal-space/pay-scale-table',
  STAFF_PERSONAL_SPACE_MY_JOURNEYS: '/staff-personal-space/my-journeys',
  STAFF_PERSONAL_SPACE_MISSION_REPORT: '/staff-personal-space/missions/:id/report',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS: '/staff-personal-space/journey-details/:id/*',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_HOME: 'home',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_GUIDE: 'guide',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_TRIP_INFORMATION: 'trip-information',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_STUDENTS: 'students',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_ACTIVITIES_AND_BUDGET: 'activities-and-budget',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_QUESTIONNAIRE: 'questionnaire',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_EXPENSES_NOTE: 'expenses-note',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_DAILY_REPORT: 'daily-report',
  STAFF_PERSONAL_SPACE_JOURNEY_DETAILS_END_OF_STAY_REPORT: 'end-of-stay-report',

  INFORMATION_REQUESTS_PAGE: '/information-requests/list',
  INFORMATION_REQUEST_CREATE_PAGE: '/information-requests/create',
  INFORMATION_REQUEST_UPDATE_PAGE: '/information-requests/update/:id',

  STAFF_LIST_PAGE: '/staffs/list',
  STAFF_CREATE_PAGE: '/staffs/create',
  STAFF_UPDATE_PAGE: '/staffs/update/:id',
  STAFF_PAY_SCALE_LIST_PAGE: '/staffs/pay-scales/list',
  STAFF_PAY_SCALE_CREATE_PAGE: '/staffs/pay-scales/create',
  STAFF_PAY_SCALE_UPDATE_PAGE: '/staffs/pay-scales/update/:id',
  STAFF_DOCUMENT_LIST_PAGE: '/staffs/documents',

  MISSION_TRACKING_LIST_PAGE: '/mission-tracking/list',
  MISSION_TRACKING_UPDATE_PAGE: '/mission-tracking/update/:id',

  CONTRACT_TEMPLATE_LIST_PAGE: '/contract-templates/list',
  CONTRACT_TEMPLATE_CREATE_PAGE: '/contract-templates/create',
  CONTRACT_TEMPLATE_UPDATE_PAGE: '/contract-templates/:id',

  STAFF_REQUEST_LIST_PAGE: '/staff-requests/list',
  STAFF_REQUEST_DETAIL_PAGE: '/staff-requests/details/:id',

  STAFF_EXPENSE_REPORT_LIST_PAGE: '/staff-expense-reports/list',
  AFFECTED_STAFF_EXPENSE_REPORT_DETAILS_PAGE: '/affected-staff-expense-reports/:id/details',
  MISSION_TO_STAFF_EXPENSE_REPORT_DETAILS_PAGE: '/mission-to-staff-expense-reports/:id/details',
  AFFECTED_STAFF_DIFFUSIONS_LIST_PAGE: '/affected-staff-diffusions/list',

  STAFF_BANK_DETAILS_LIST_PAGE: '/staff-bank-details/list',
  TRAVEL_EXPENSES_STAFF_SALARY_LIST_PAGE: '/travel-expenses/staff-salary/list',

  COUNTRY_LIST_PAGE: '/countries/list',
  COUNTRY_CREATE_PAGE: '/countries/create',
  COUNTRY_UPDATE_PAGE: '/countries/:id',

  JOURNEY_PLACE_LIST_PAGE: '/journey-places/list',
  JOURNEY_PLACE_CREATE_PAGE: '/journey-places/create',
  JOURNEY_PLACE_UPDATE_PAGE: '/journey-places/:id',

  JOURNEY_LIST_PAGE: '/journey/list',

  AFFECTED_STAFFS_LIST_PAGE: '/staffs/affected/list',
  AFFECTED_STAFFS_VIEW_PAGE: '/staffs/affected/:id/view',
  AFFECTED_STAFFS_PROFILE_PAGE: '/staffs/affected/:id/profile',
  AFFECTED_STAFFS_SALARIES_LIST_PAGE: '/staffs/affected/salaries/list',
  MISSION_TRACKINGS_SALARIES_LIST_PAGE: '/staffs/mission-trackings/salaries/list',

  ACCOUNTANT_PERSONAL_SPACE_AFFECTED_STAFFS_SALARIES_LIST_PAGE:
    '/accountant-personal-space/affected-staffs/salaries/list',
  ACCOUNTANT_PERSONAL_SPACE_MISSION_TRACKINGS_SALARIES_LIST_PAGE:
    '/accountant-personal-space/mission-trackings/salaries/list',

  FORMULA_WISH_LIST: '/journey-places/formulas-wish-list',
  FORMULA_WISH_LIST_CREATE_PAGE: '/journey-places/formulas-wish-list/create',
  FORMULA_WISH_LIST_UPDATE_PAGE: '/journey-places/formulas-wish-list/:id',
  JOURNEY_PLACE_OPTIONS_LIST_PAGE: '/journey-places/options/list',
  JOURNEY_PLACE_OPTION_CREATE_PAGE: '/journey-places/options/create',
  JOURNEY_PLACE_OPTION_UPDATE_PAGE: '/journey-places/options/:id',

  TRIPS_LIST: '/trips/list',
  TRIP_CREATE_PAGE: '/trips/create',
  TRIP_UPDATE_PAGE: '/trips/update/:id',

  LEC_BANK_ACCOUNTS_LIST_PAGE: '/lec-bank-accounts/list',
  LEC_BANK_ACCOUNTS_CREATE_PAGE: '/lec-bank-accounts/create',
  LEC_BANK_ACCOUNTS_UPDATE_PAGE: '/lec-bank-accounts/update/:id',

  CENTER_OL_PAYMENTS_LIST_PAGE: '/center-ol-payments/list',
  CENTER_OL_PAYMENTS_CREATE_PAGE: '/center-ol-payments/create',
  CENTER_OL_PAYMENTS_UPDATE_PAGE: '/center-ol-payments/update/:id',

  CENTER_PAYMENTS_LIST_PAGE: '/center-payments/list',

  RAD_LIST_PAGE: '/rads/list',
  RAD_CREATE_PAGE: '/rads/create',
  RAD_UPDATE_PAGE: '/rads/update/:id',

  TRIP_GROUPING_LIST_PAGE: '/trip-groupings/list',
  TRIP_GROUPING_CREATE_PAGE: '/trip-groupings/create',
  TRIP_GROUPING_UPDATE_PAGE: '/trip-groupings/update/:id',

  PRODUCTS_LIST_PAGE: '/products/list',
  PRODUCT_CREATE_PAGE: '/products/create',
  PRODUCT_UPDATE_PAGE: '/products/update/:id',

  OL_LIST_PAGE: '/ols/list',
  OL_CREATE_PAGE: '/ols/create',
  OL_UPDATE_PAGE: '/ols/update/:id',
  OL_HOST_FAMILY_INFORMATION: '/ols/host-family-information/:id',
  OL_DETAILS_PAGE: '/ols/details/:id/*',
  OL_DETAILS_UPDATE_PAGE: 'update',
  OL_DETAILS_HOST_FAMILIES_PAGE: 'host-families',
  OL_DETAILS_TEFLS_PAGE: 'tefls',
  OL_TEFL_DETAILS_PAGE: '/ols/tefls/:olId/:teflId',

  OL_HOST_FAMILY_GLOBAL_LIST_PAGE: '/ols/host-families/global-list',
  OL_TEFL_GLOBAL_LIST_PAGE: '/ols/tefls/global-list',
  OL_TEACHING_HALL_GLOBAL_LIST_PAGE: '/ols/teaching-halls/global-list',
  OL_COACH_COMPANIES_GLOBAL_LIST_PAGE: '/ols/coach-companies/global-list',

  CSE_LIST_PAGE: '/cse/list',
  CSE_CREATE_PAGE: '/cse/create',
  CSE_UPDATE_PAGE: '/cse/update/:id',

  OL_CENTER_LIST_PAGE: '/ols/centers/list',
  OL_CENTER_DETAILS_PAGE: '/ols/centers/details/:id/*',
  OL_CENTER_PLACEMENTS: 'placements',
  OL_CENTER_GROUPS: 'groups',
  OL_CENTER_COST: 'cost',
  OL_CENTER_ACTIVITIES_TEFL_AND_TEACHING_HALLS: 'activities-tefl-and-teaching-halls',
  OL_CENTER_TRIP_INFORMATION: 'trip-information',
  OL_CENTER_FINAL_COST: 'final',
  OL_CENTER_EVENTS: 'events',
  OL_CENTER_END_OF_STAY_APPRECIATIONS: 'end-of-stay-appreciations',

  OL_HOST_FAMILIES_LIST_PAGE: '/service-provider/host-families-list',
  OL_HOST_FAMILIES_CREATE_PAGE: '/service-provider/host-families-list/create',
  OL_HOST_FAMILIES_UPDATE_PAGE: '/service-provider/host-families-list/update/:id',

  OL_TEFL_LIST_PAGE: '/service-provider/tefl',
  OL_TEFL_CREATE_PAGE: '/service-provider/tefl/create',
  OL_TEFL_UPDATE_PAGE: '/service-provider/tefl/update/:olId/:id',

  OL_DETAILS_TEFL_PRICES_PAGE: 'tefl-prices',
  OL_DETAILS_CREATE_TEFL_PRICES_PAGE: 'tefl-prices/create',
  OL_DETAILS_UPDATE_TEFL_PRICES_PAGE: 'tefl-prices/edit/:teflPriceId',

  OL_DETAILS_HOST_FAMILY_PRICES_PAGE: 'host-family-prices',
  OL_DETAILS_CREATE_HOST_FAMILY_PRICES_PAGE: 'host-family-prices/create',
  OL_DETAILS_UPDATE_HOST_FAMILY_PRICES_PAGE: 'host-family-prices/edit/:hostFamilyPriceId',

  OL_DETAILS_ACCESS_RIGHTS_PAGE: 'access-rights',
  OL_DETAILS_TEACHING_HALLS_PAGE: 'teaching-halls',
  OL_TEACHING_HALL_VIEW_PAGE: '/teaching-halls/view/:olId/:id',

  OL_COMMISSIONS_LIST_PAGE: '/ols/commissions/list',
  OL_COMMISSION_CREATE_PAGE: '/ols/commissions/create',
  OL_COMMISSION_UPDATE_PAGE: '/ols/commissions/update/:id',

  OL_PERSONAL_SPACE_HOST_FAMILIES_LIST_PAGE: '/ol-personal-space/host-families-list',
  OL_PERSONAL_SPACE_HOST_FAMILIES_CREATE_PAGE: '/ol-personal-space/host-families-list/create',
  OL_PERSONAL_SPACE_HOST_FAMILIES_UPDATE_PAGE: '/ol-personal-space/host-families-list/update/:id',

  OL_FEES_LIST_PAGE: '/service-provider/fees/*',
  OL_FEES_COMMISSIONS_LIST_PAGE: 'commission',
  OL_FEES_HOST_FAMILY_PRICE_LIST_PAGE: 'host-family-prices',
  OL_FEES_TEFL_PRICE_LIST_PAGE: 'telf-prices',

  TEACHING_HALLS_LIST_PAGE: '/teaching-halls/list',
  TEACHING_HALL_CREATE_PAGE: '/teaching-halls/create',
  TEACHING_HALL_UPDATE_PAGE: '/teaching-halls/update/:id',

  OL_PERSONAL_SPACE_MOBILE_NUMBERS_FOR_FRENCH_LEADERS_LIST_PAGE:
    '/ol-personal-space/mobile-numbers-for-french-leaders/list',

  OL_MOBILE_NUMBERS_FOR_FRENCH_LEADERS_LIST_PAGE: 'mobile-numbers-for-french-leaders',

  OL_ACTIVITY_LIST_PAGE: 'activities',
  OL_ACTIVITY_VIEW_PAGE: '/ols/:olId/activities/view/:id',

  OL_PERSONAL_SPACE_ACTIVITY_LIST_PAGE: '/ol-personal-space/activities/list',
  OL_PERSONAL_SPACE_ACTIVITY_CREATE_PAGE: '/ol-personal-space/activities/create',
  OL_PERSONAL_SPACE_ACTIVITY_UPDATE_PAGE: '/ol-personal-space/activities/update/:id',

  OL_PERSONAL_SPACE_COACH_COMPANIES_LIST_PAGE: '/ol-personal-space/coach-companies/list',
  OL_PERSONAL_SPACE_COACH_COMPANIES_CREATE_PAGE: '/ol-personal-space/coach-companies/create',
  OL_PERSONAL_SPACE_COACH_COMPANIES_UPDATE_PAGE: '/ol-personal-space/coach-companies/update/:id',

  OL_PERSONAL_SPACE_CENTER_LIST_PAGE: '/ol-personal-space/centers/list',
  OL_PERSONAL_SPACE_CENTER_DETAILS_PAGE: '/ol-personal-space/centers/details/:id/*',
  OL_PERSONAL_SPACE_CENTER_PLACEMENTS: 'placements',
  OL_PERSONAL_SPACE_CENTER_COST: 'cost',
  OL_PERSONAL_SPACE_CENTER_ACTIVITIES_TEFL_AND_TEACHING_HALLS:
    'activities-tefl-and-teaching-halls',
  OL_PERSONAL_SPACE_CENTER_TRIP_INFORMATION: 'trip-information',
  OL_PERSONAL_SPACE_CENTER_FINAL_COST: 'final',
  OL_PERSONAL_SPACE_CENTER_EVENTS: 'events',

  OL_COACH_COMPANIES_LIST_PAGE: 'coach-companies',
  OL_COACH_COMPANIES_CREATE_PAGE: '/ols/:olId/coach-companies/create',
  OL_COACH_COMPANIES_VIEW_PAGE: '/ols/:olId/coach-companies/view/:id',

  TRIP_BOOKING_LIST_PAGE: '/trip-bookings/list',
  TRIP_BOOKING_CREATE_PAGE: '/trip-bookings/create',
  TRIP_BOOKING_UPDATE_PAGE: '/trip-bookings/:id',

  TRANSFER_LIST_PAGE: '/transfers/list',
  TRANSFER_CREATE_PAGE: '/transfers/create',
  TRANSFER_UPDATE_PAGE: '/transfers/update/:id',

  TRIP_DATES_LIST_PAGE: '/trip-dates/list',
  TRIP_DATES_UPDATE_PAGE: '/trip-dates/:id',
  PRIMARY_BOOKED_TRIP_DATES_LIST_PAGE: '/primary-trip-dates-booked/list',
  SECONDARY_BOOKED_TRIP_DATES_LIST_PAGE: '/secondary-trip-dates-booked/list',

  MISSION_TYPE_LIST_PAGE: '/missions-types/list',
  MISSION_TYPE_UPDATE_PAGE: '/missions-types/update/:id',
  MISSION_TYPE_CREATE_PAGE: '/missions-types/create',

  TRIP_STEPS_LIST_PAGE: '/trip-steps/list',

  TRIP_PROVIDER_LIST_PAGE: '/trip-providers/list',
  TRIP_PROVIDER_CREATE_PAGE: '/trip-providers/create',
  TRIP_PROVIDER_UPDATE_PAGE: '/trip-providers/:id',

  TRIP_ADDRESS_LIST_PAGE: '/trip-addresses/list',
  TRIP_ADDRESS_CREATE_PAGE: '/trip-addresses/create',
  TRIP_ADDRESS_UPDATE_PAGE: '/trip-addresses/update/:id',

  TRIP_BOOKING_GUIDELINE_LIST_PAGE: '/trip-booking-guidelines/list',
  TRIP_BOOKING_GUIDELINE_CREATE_PAGE: '/trip-booking-guidelines/create',
  TRIP_BOOKING_GUIDELINE_UPDATE_PAGE: '/trip-booking-guidelines/update/:id',

  TRIP_FOLDER_LIST_PAGE: '/trip-folder/list',
  TRIP_FOLDER_DETAILS_PAGE: '/trip-folder/:id/details/*',
  TRIP_FOLDER_TICKETS_PAGE: 'tickets',
  TRIP_FOLDER_PASSENGER_DETAILS: 'passengers',
  TRIP_FOLDER_DOCUMENTS_PAGE: 'documents',

  TRIPS_MONITORING: '/trips-monitoring',

  ENROLLMENT_QUOTATION_LIST_PAGE: '/enrollment-quotation/list',
  ENROLLMENT_QUOTATION_CREATE_PAGE: '/enrollment-quotation/create',
  ENROLLMENT_QUOTATION_UPDATE_PAGE: '/enrollment-quotation/:id',

  LANGUAGE_TEST_TEMPLATE_LIST_PAGE: '/language-test/list',
  LANGUAGE_TEST_TEMPLATE_DETAILS_PAGE: '/language-test/:id',
  LANGUAGE_TEST_TEMPLATE_SECTION_DETAILS_PAGE: '/language-test/:templateId/section/:sectionId',

  ENROLLMENT_LIST_PAGE: '/enrollments/list',
  ENROLLMENT_VALIDATED_LIST_PAGE: '/enrollments/validated-list',
  ENROLLMENT_CREATE_PAGE: '/enrollments/create',
  ENROLLMENT_UPDATE_PAGE: '/enrollments/:id',

  ENROLLMENT_ACCEPT_CSE_PAGE: '/enrollments/:id/accept-cse',
  ENROLLMENT_REJECT_CSE_PAGE: '/enrollments/:id/reject-cse',

  PAYMENT_CONDITIONS_LIST_PAGE: '/payment-conditions/list',
  PAYMENT_CONDITIONS_CREATE_PAGE: '/payment-conditions/create',
  PAYMENT_CONDITIONS_UPDATE_PAGE: '/payment-conditions/:id',

  INSURANCE_LIST_PAGE: '/insurances/list',
  INSURANCE_CREATE_PAGE: '/insurances/create',
  INSURANCE_UPDATE_PAGE: '/insurances/:id',

  PROMO_CODE_LIST_PAGE: '/promo-codes/list',
  PROMO_CODE_CREATE_PAGE: '/promo-codes/create',
  PROMO_CODE_UPDATE_PAGE: '/promo-codes/:id',

  AA_KEYWORD_LIST_PAGE: '/aa-keywords/list',
  AA_KEYWORD_CREATE_PAGE: '/aa-keywords/create',
  AA_KEYWORD_UPDATE_PAGE: '/aa-keywords/:id',

  YOUTH_AND_SPORT_NUMBER_LIST_PAGE: '/youth-and-sport-numbers/list',
  YOUTH_AND_SPORT_NUMBER_CREATE_PAGE: '/youth-and-sport-numbers/create',
  YOUTH_AND_SPORT_NUMBER_UPDATE_PAGE: '/youth-and-sport-numbers/:id',

  MEDICAL_TERM_LIST_PAGE: '/medical-terms/list',
  MEDICAL_TERM_CREATE_PAGE: '/medical-terms/create',
  MEDICAL_TERM_UPDATE_PAGE: '/medical-terms/:id',

  GUIDE_LIST_PAGE: '/guides/list',
  GUIDE_CREATE_PAGE: '/guides/create',
  GUIDE_UPDATE_PAGE: '/guides/:id',

  CHARACTERISTICS_LIST_PAGE: '/characteristics/list',

  HOW_DID_YOU_OBTAIN_LEC_BROCHURE_LIST_PAGE: '/how-did-you-obtain-lec-brochure/list',

  MISSION_LIST_PAGE: '/missions/list',
  MISSION_LIST_STAFF_PAGE: '/missions/staff/list',
  MISSION_VIEW_PAGE: '/missions/view/:id',

  CAN_GO_OUT_ALONE_CONDITION_LIST_PAGE: '/can-go-out-alone-conditions/list',
  CAN_GO_OUT_ALONE_CONDITION_CREATE_PAGE: '/can-go-out-alone-conditions/create',
  CAN_GO_OUT_ALONE_CONDITION_UPDATE_PAGE: '/can-go-out-alone-conditions/:id',

  CENTER_LIST_PAGE: '/centers/list',
  CREATE_CENTER_PAGE: '/centers/create',
  CENTER_DETAILS_PAGE: '/centers/details/:id/*',

  CENTER_GLOBAL_VIEW_PAGE: 'global-view',
  CENTER_GROUPS_PAGE: 'groups',
  CENTER_YOUNG_PEOPLE_PAGE: 'young-people',
  CENTER_STAFFS_PAGE: 'staffs',
  CENTER_TRIPS_PAGE: 'trips',
  CENTER_FOREIGN_PROVIDER_PAGE: 'foreign-provider',
  CENTER_STAY_EVENTS_PAGE: 'stay-events',
  CENTER_STATISTICS_PAGE: 'statistics',

  CENTER_EVENT_DETAILS_PAGE: '/centers/:id/events/:eventId/details',
  ENROLLMENT_PROFILE_PAGE: '/student-profile/:id',

  CENTER_EVENT_LIST_PAGE: '/center-events/list',

  AUTH_CLIENT_LOGIN_PAGE: '/auth/client-login',
  AUTH_CHECK_EMAIL_PAGE: '/auth/check-email',
  CLIENT_PERSONAL_SPACE_REDIRECTION: '/client-personal-space/redirection',
  CLIENT_SPACE_LAYOUT: '/client-personal-space/:id/*',
  CLIENT_PERSONAL_SPACE_HOME: 'home',
  CLIENT_PERSONAL_SPACE_INFORMATION_TEST_LEVEL: 'information/test-level',
  CLIENT_PERSONAL_SPACE_INFORMATION_CHILD_PROFILE: 'information/child-profile',
  CLIENT_PERSONAL_SPACE_INFORMATION_PICKUP: 'information/pickup',
  CLIENT_PERSONAL_SPACE_INFORMATION_TRIPS: 'information/trips',
  CLIENT_PERSONAL_SPACE_INFORMATION_INDIVIDUAL_TRIP: 'information/individual-trip',
  CLIENT_PERSONAL_SPACE_INFORMATION_IDENTITY: 'information/identity',
  CLIENT_PERSONAL_SPACE_INFORMATION_MEDICAL_STATEMENT: 'information/medical-statement',
  CLIENT_PERSONAL_SPACE_PAYMENT: 'reservation/payment',
  CLIENT_PERSONAL_SPACE_FINALIZE_PAYMENT: 'reservation/finalize-payment',
  CLIENT_PERSONAL_SPACE_CANCEL_JOURNEY: 'reservation/cancel-journey',
  CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_LEC_GUIDE: 'trip-information/lec-guide',
  CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_CONTACT: 'trip-information/contact',
  CLIENT_PERSONAL_SPACE_TRIP_INFORMATION_OTO_CONTACT: 'trip-information/oto-contact',
  CLIENT_PERSONAL_SPACE_JOURNEY_PREPARATION: 'journey-preparation',
  CLIENT_PERSONAL_SPACE_DEPARTURE_CHECKLIST: 'departure-checklist',
  CLIENT_PERSONAL_SPACE_ADMINSTRATION_PROCEDURES: 'administration-procedures',

  BUDGET_ALLOCATION_LIST_PAGE: '/allocation-budgets/list',
  BUDGET_ALLOCATION_CREATE_PAGE: '/allocation-budgets/create',

  CLIENT_PAYMENTS_LIST_PAGE: '/client-payments/list',

  SURVEY_END_OF_STAY_TEMPLATES_LIST_PAGE: '/surveys/end-of-stay-templates/list',
  SURVEY_END_OF_STAY_TEMPLATE_CREATE_PAGE: '/surveys/end-of-stay-templates/create',
  SURVEY_END_OF_STAY_TEMPLATE_UPDATE_PAGE: '/surveys/end-of-stay-templates/update/:id',

  SURVEY_END_OF_STAY_TEMPLATE_QUESTIONS_LIST_PAGE:
    '/surveys/end-of-stay-templates/:id/questions/list',

  SURVEY_END_OF_STAY_QUESTIONNAIRES_PROCESSING_PAGE:
    '/surveys/end-of-stay-questionnaires/processing',

  SURVEY_END_OF_STAY_APPRECIATIONS_SUMMARY_PAGE: '/surveys/end-of-stay-appreciations',

  OTO_INDIVIDUAL_PLACE_PERIODS_LIST_PAGE: '/oto-individual-places/periods/list',
  OTO_INDIVIDUAL_PLACES_BY_PERIOD_LIST_PAGE: '/oto-individual-places/by-period/:id/list',

  UI_INPUTS_PAGE: '/ui-inputs'
} as const

export type PathsType = typeof Paths
